<p-card>
    <ng-template pTemplate="header">
        <div class="flex flex-col gap-4">
            <div class="p-card-title">
                @if(locationList()) {
                {{locationList()}}
                }
                @else {
                Overall
                }
            </div>
            <div class="flex gap-4">
                <div class="flex gap-1 items-center">
                    <label class="font-semibold">Location</label>
                    <!-- <app-location-dropdown [(ngModel)]="location" [locations]="locationOptions()"
                        [allowEmpty]="true"></app-location-dropdown> -->
                    <app-location-multi-dropdown [(ngModel)]="locations"
                        [options]="locationOptions()"></app-location-multi-dropdown>
                </div>
                <!-- <div class="flex gap-1 items-center">
                    <label class="font-semibold">Years</label>
                    <p-multiSelect [options]="yearOptions" [(ngModel)]="selectedYears"></p-multiSelect>
                </div> -->


            </div>
        </div>
    </ng-template>



    @if(loading()) {
    <p-skeleton styleClass="w-full h-[30rem]"></p-skeleton>
    }
    <div class="w-full">
        <app-trip-actual-history-graph [class.hidden]="loading()" [years]="selectedYears()" [locations]="locations()"
            (loading)="chartLoading($event)"></app-trip-actual-history-graph>
    </div>



</p-card>